import { css } from '@repo/panda/css';

export const heroSectionStyles = css.raw({
    zIndex: 1,
    padding: '16',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
    _after: {
        content: '""',
        position: 'absolute',
        top: '0',
        left: '0',
        width: 'full',
        height: 'full',
        background: '[linear-gradient(0deg, #131417 70%, rgba(19, 20, 23, 0.00) 100%)]',
        zIndex: -1,
    },
    _before: {
        content: '""',
        position: 'absolute',
        top: '0',
        left: '0',
        width: 'full',
        height: 'full',
        background: 'blackAlpha.60',
        zIndex: -1,
    },
});

export const dividerStyles = css({
    borderColor: 'whiteAlpha.10',
    borderBottomWidth: '0px',
    borderTopWidth: '1px',
    borderStyle: 'solid',
    width: 'full',
});

export const sidebarHeroFrameStyles = css.raw({
    zIndex: 1,
    position: 'relative',
    overflow: 'hidden',
    height: 'full',
});

export const heroImageLayerStyles = css({
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    height: '[232px]',
    opacity: '[0.5]',
    backgroundSize: 'cover',
    backgroundPosition: 'top center',
    backgroundRepeat: 'no-repeat',
    maskImage: '[linear-gradient(180deg, black 0%, transparent 100%)]',
    // Safari still requires the prefix
    WebkitMaskImage: '[linear-gradient(180deg, black 0%, transparent 100%)]',
    pointerEvents: 'none',
    zIndex: -1,
});

export const sidebarScrollAreaStyles = css({
    height: 'full',
    width: 'full',
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: '16',
});

export const scrollFadeTopStyles = css({
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    height: '[32px]',
    background: '[linear-gradient(180deg, rgba(19, 20, 23, 0.9) 0%, rgba(19, 20, 23, 0) 100%)]',
    pointerEvents: 'none',
    zIndex: 2,
    transition: 'opacity',
});

export const scrollFadeBottomStyles = css({
    position: 'absolute',
    bottom: '0',
    left: '0',
    right: '0',
    height: '[40px]',
    background: '[linear-gradient(0deg, rgba(19, 20, 23, 0.95) 0%, rgba(19, 20, 23, 0) 100%)]',
    pointerEvents: 'none',
    zIndex: 2,
    transition: 'opacity',
});
